import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const deleteTeam = (teamId: number) => api.delete(`/teams/${teamId}`);

export const useDeleteTeamMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}) => {
  return useMutation({
    mutationKey: ['deleteTeam'],
    mutationFn: deleteTeam,
    onSuccess,
    onError,
  });
};
